import React from "react";
import image from "../assets/images/Capture.png";

export default function CommitmentToExcellence() {
  return (
    <div
      className="bg-white flex justify-center items-center py-5"
      onContextMenu={(e) => e.preventDefault()} 
    >
      <div
        className="relative w-[75%] max-w-[1200px] h-[600px] select-none"
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div
          className="absolute inset-0 z-10 pointer-events-auto"
          onContextMenu={(e) => e.preventDefault()} 
        />
      </div>
    </div>
  );
}
